import { Stack, Typography, useTheme } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { DataGrid } from "components/DataGrid";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";

import { paymentSectionColumns, PaymentSectionRow } from "./lib/paymentSectionColumns";

const paymentHistoryColumns: GridColDef<PaymentSectionRow>[] = [
  ...paymentSectionColumns,
  {
    headerName: "Status",
    field: "status",
    flex: 0.8,
    renderCell: (p) => prettyPrintEnumValue(p.value),
  },
];

/**
 * Read-only reference on the fulfillment ticket: every OTHER payment linked to
 * this facility — across prior years and any report or submission, including
 * cancelled — so staff can catch an existing payment before paying again.
 */
export function PaymentHistorySection({ payments }: { payments: PaymentSectionRow[] }) {
  const theme = useTheme();

  return (
    <Stack spacing={theme.spacing(1)}>
      <Typography variant="h6">Payment history for this facility</Typography>
      <Typography variant="body2" color="text.secondary">
        All other payments linked to this facility — across prior years and any report or
        submission, including cancelled ones. Check here before paying to avoid duplicates.
      </Typography>
      <DataGrid<PaymentSectionRow>
        hideFooter
        disableRowSelectionOnClick
        rows={payments}
        initialState={{ sorting: { sortModel: [{ field: "paidAt", sort: "desc" }] } }}
        columns={paymentHistoryColumns}
      />
    </Stack>
  );
}
